import { Route, Routes, Navigate } from 'react-router-dom';
import { Box, Spinner, Center } from '@chakra-ui/react';
import { Suspense, lazy } from 'react';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { RedirectToLogin } from '@propelauth/react';
import { SentryTest } from '../components/SentryTest';
// Lazy load components
const Dashboard = lazy(() => import('../pages/Dashboard'));
const VoiceOnboarding = lazy(() => import('../pages/VoiceOnboarding'));
const IntroScreen = lazy(() => import('../pages/Intro/IntroScreen'));
const IntroVoiceLayout = lazy(() =>
  import('../pages/Intro/IntroVoiceLayout').then((m) => ({ default: m.IntroVoiceLayout }))
);
const Projects = lazy(() => import('../pages/Projects'));
const ViewReport = lazy(() => import('../pages/ViewReport'));
const ProjectDetail = lazy(() => import('../pages/ProjectDetail'));
const MigrationProjects = lazy(() => import('../pages/MigrationProjects'));
const MigrationChat = lazy(() =>
  import('../features/migration/components/MigrationChat').then(
    (module) => ({ default: module.MigrationChat })
  )
);
const Settings = lazy(() => import('../pages/Settings'));
const AboutHaven = lazy(() => import('../pages/AboutHaven'));
const AdaptationProjects = lazy(() => import('../pages/AdaptationProjects'));

// Loading component
const LoadingSpinner = () => (
  <Center h="100vh">
    <Spinner size="xl" />
  </Center>
);

export function App() {
  return (
    <Box>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {/* Public Routes */}

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/intro" element={<IntroVoiceLayout><IntroScreen /></IntroVoiceLayout>} />
            <Route path="/onboarding" element={<VoiceOnboarding />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/view-report/:reportId" element={<ViewReport />} />
            <Route path="/project/:projectId" element={<ProjectDetail />} />
            <Route path="/migration-projects" element={<MigrationProjects />} />
            <Route path="/migration-analysis" element={<MigrationChat />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/about-haven" element={<AboutHaven />} />
            <Route path="/adaptation-projects" element={<AdaptationProjects />} />
            <Route
              path="/profile"
              element={<div>User Profile (Protected)</div>}
            />
            <Route path="/explore" element={<div>Explore (Protected)</div>} />
            <Route path="/adapt" element={<div>Adapt (Protected)</div>} />
          </Route>

          {/* Auth Routes */}
          <Route path="/login" element={<RedirectToLogin />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Suspense>
      <SentryTest />
    </Box>
  );
}

export default App;
